import styled from 'styled-components';
import { TABLET_WIDTH } from 'constants/breakPoints';

export const ThinkSection = styled.div`
  padding: 2rem 0;

  .title_section {
    margin-left: 1rem;
  }
`;

export const ThinkContent = styled.div`
  .text {
    color: black;
    font-size: 1.5rem;
    margin-left: 1rem;
  }
  .title {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-left: 3rem;
    height: 5rem;
  }
`;

export const ThinkTabs = styled.div`
  background-color: rgba(0, 0, 0, 0.05);
  white-space: nowrap;
`;

export const ThinkTab = styled.div`
  width: 50%;
  display: inline-block;
  text-align: center;
  padding: 10px;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  position: relative;

  ${props => (props.active ? 'border-bottom: 2px solid #fff' : '')};

  @media (max-width: ${TABLET_WIDTH}px) {
    font-size: 14px;
  }

  .tab_indicator {
    font-size: 14px;
    color: #ff0000;
  }

  .alert_in_tab {
    background-color: #ff0000;
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    top: calc(50% - 5px);
    right: 10px
  }
`;

export const TabContent = styled.div`
  display: ${props => (props.flex ? 'flex' : '')};
  width: 100%;
  margin: 0 auto;
  .tables {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;

    @media (max-width: ${TABLET_WIDTH}px) {
      display: block;
    }
  }
  .buttonAdd {
    position: fixed;
    bottom: 2rem;
    right: 2rem;
    @media (max-width: ${TABLET_WIDTH}px) {
      bottom: calc(8rem + env(safe-area-inset-bottom));
      right: 1rem;
      z-index: 10;
      height: 6rem;
    }
  }
`;

export const Subtitle = styled.div`
  color: #fff;
  font-size: 14px;
  margin: 20px auto;

  @media (max-width: ${TABLET_WIDTH}px) {
    font-size: 12px;
    margin: 10px auto;
  }
`;

export const Buttons = styled.div`
  text-align: right;
`;

export const ElementsList = styled.div`
  margin-top: 10px;
  padding-bottom: 20px;

  .chat_element {
    width: 100%;
  }
`;

export const CreateButton = styled.div`
  background: #2680EB;
  height: 5.5rem;
  width: 5.5rem;
  color: white;
  font-size: 3rem;
  position: fixed;
  right: min(5vw, 2rem);
  z-index: 100;
  cursor: pointer;
  bottom: 2rem;
  @media (max-width: ${TABLET_WIDTH}px) {
    bottom: 10rem;
  }
  border-radius: 3rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NoContent = styled.div`
  .text {
    color: black;
    font-size: 1.5rem;
  }
  .no_content{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 4rem;

    img {
      width: 20rem;
      margin-top: 3rem;
    }
  }

  .other_chats{
    margin-top: 4rem;
    .other_ongoing {
      height: 3rem;
      .title {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-left: 3rem;
        height: 3rem;
      }
      img {
        color: #99C9BF;
        margin-right: 2rem;
      }
    }
  }
`;


export const NoContentWrapper = styled.div`
  width: 100%;
  height: 30rem;
  padding: 2rem;
  background: #F3F3F3;
  border-radius: 3rem;
  display: flex;
  align-items: center;
  .nocontent{
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    img {
      width: 20rem;
    }
    .text {
      margin-top: 1rem;
      font-size: 1.6rem;
      text-align: center;
    }
  }
`;

export const NewTable = styled.div`
  min-height: 20rem;
  min-width: 20rem;
  max-height: 20rem;
  max-width: 20rem;
  border-radius: 100%;
  margin: 2rem;
  background: #2680EB;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  .plus{
    font-size: 5rem;
  }
  .text {
    font-size: 2rem;
    margin: 1rem;
    color: white;
  }
`;

export const ThemeTableWrapper = styled.div`
  width: 90%;
  padding: 2rem;
  margin: 1rem;
  box-shadow: 0px 0px 6px 1px rgb(0 0 0 / 20%);
  border-radius: 4rem;
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  background-color: ${props => (props.dead ? '#bfbfbf' : '#ffffff')};
  .separator {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-left: 0.1rem solid gray;
    height: 60%;
  }
  .buttons_right {
    position: absolute;
    left: 50%;
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 2rem;
    justify-content: center;
  }

  @media (max-width: ${TABLET_WIDTH}px) {
    width: 200%;
    padding: 0;
    position: relative;
    overflow-x: auto;
    overflow-y: hidden;
    height: 15rem;

    .theme_table_card {
      transform: scale(0.5);
      margin-top: 1rem;
      width :13rem;
    }
  }
`;

export const ThemeTableDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  left: 25%;
  width: 20%;
  height: 100%;
  justify-content: center;

  @media (max-width: ${TABLET_WIDTH}px) {
    left: 18%;
    width: 29%;
  }
  .name {
    font-size: 1.4rem;
    font-weight: bold;
    margin-left: 3rem;
    margin: 1rem;
    text-align: center;
  }
  .time {
    font-size: 1.2rem;
    text-align: center;

    .countdown {
      margin-left: 0.5rem;
    }
  }
`;

export const AddButton = styled.div`
  background: #2680EB;
  border-radius: 100%;
  font-size: 4rem;
  color: white;
  cursor: pointer;
  width: 2rem;
  height: 2rem;
  padding: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonViewDetail = styled.div`
    background: #2680EB;
    color: white;
    font-size: 1.3rem;
    padding: 2rem;
    border-radius: 3rem;
`;

export const ThemeTableOverflow = styled.div`
  width: 100%;
  @media (max-width: ${TABLET_WIDTH}px) {
    overflow: auto;
    margin-right: 2rem;
  }
`;

export const LastMessageWrapper = styled.div`
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .avatar{
    position: absolute;
    left: 9%;
  }
  .text {
    background: #2680EB;
    color: white;
    width: 70%;
    padding: 2rem;
    border-radius: 1rem;
  }
`;

export const CreateTable = styled.div`
  position: fixed;
  bottom: 4rem;
  right: 4rem;

  @media (max-width: ${TABLET_WIDTH}px) {
    bottom: 8rem;
    right: 2rem;
  }
`;



// WEBPACK FOOTER //
// ./src/routes/Think/components/styles.js